import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getSchoolDropdown = async () => {
  return serviceHelper(http.get('/admin/school/dropdown'), false);
};

export const getClassDropdown = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(
      `/admin/school/class/dropdown${queryString ? `?${queryString}` : ''}`
    ),
    false
  );
};

export const getTeacherDropdown = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(
      `/admin/school/teacher/dropdown${queryString ? `?${queryString}` : ''}`
    ),
    false
  );
};

export const blockUnblockRecordAPI = async (payload: {
  id: string;
  record_type: number;
  is_block: boolean;
}) => {
  const { id, record_type, is_block } = payload;
  return serviceHelper(
    http.patch(`/admin/block-unblock/${id}?record_type=${record_type}`, {
      is_block,
    }),
    true
  );
};

export const softdeleteRecord = async (params: {
  id: string;
  record_type: number;
}) => {
  const { id, record_type } = params;
  return serviceHelper(
    http.delete(`/admin/restore/${id}?record_type=${record_type}`),
    false
  );
};

export const getDeletedRecords = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/admin/restore${queryString ? `?${queryString}` : ''}`),
    false
  );
};

export const restoreRecord = async (id: string) => {
  return serviceHelper(http.post(`/admin/restore/${id}`), true);
};

export const deleteRecordPermanently = async (params: {
  id: string;
  record_type: string;
}) => {
  const { id, record_type } = params;
  return serviceHelper(
    http.delete(
      `/admin/restore/permanently-delete/${id}?record_type=${record_type}`,
      {
        data: { id, record_type },
      }
    ),
    true
  );
};
